/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import sendIconUrl from "images/send-icon.svg";
import styled from "styled-components";
import { fontFamilies } from "components/shared/Styles";

const FeedbackButtonStyling = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  margin-left: 5px;
  margin-top: 24px;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    img {
      width: 18px;
      height: 18px;
    }

    a {
      font: normal normal normal 18px/22px ${fontFamilies};
      text-decoration: none;
      color: black;
    }
  }
`;

const FeedbackButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const FeedbackButtonImg = styled.img`
  width: 18px;
  height: 18px;
`;

const FeedbackButtonHyperlink = styled.a`
  font: normal normal normal 18px/22px ${fontFamilies};
  text-decoration: none;
  color: black;
`;

export const FeedbackButton: React.FC = () => {
  return (
    <FeedbackButtonStyling>
      <FeedbackButtonDiv>
        <FeedbackButtonImg src={sendIconUrl} alt="" />
        <FeedbackButtonHyperlink
          target="_blank"
          href="https://survey.adobe.com/jfe/form/SV_bei8D4HdAppNRNI"
        >
          {I18n.t("give_feedback")}
        </FeedbackButtonHyperlink>
      </FeedbackButtonDiv>
    </FeedbackButtonStyling>
  );
};
